import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');

export class FormHiddenComponent extends HTMLElement {
    constructor() {
        super();
        const defaultValue = this.getAttribute('data-default-value')

        template.innerHTML = `<input type="hidden" class="form-control" value="` + defaultValue + `">`

        initWebComponent(this, template)
    }
}
